import { MaternityFile } from '../../types'
import { getPostnatalReviewStatus, PostnatalReviewKind } from './postnatalSchedule'

export type MaternityWardStage = 'antenatal' | 'labour' | 'postnatal'

export type MaternityWardFilter = 'all' | MaternityWardStage

export function getMaternityWardStage(file: MaternityFile): MaternityWardStage {
  const delivery: any = file.delivery || {}
  const delivered =
    (delivery.deliverySummary || []).length > 0 ||
    Boolean(delivery.placentaDeliveredDate) ||
    Boolean(delivery.deliveryMethod) ||
    Boolean(file.dischargeSlip?.dateOfDischarge)
  if (delivered) return 'postnatal'

  const inLabour =
    (file.labourObservations || []).length > 0 ||
    Boolean(delivery.firstStageBeganDate) ||
    Boolean(delivery.completeDilationDate)
  if (inLabour) return 'labour'

  return 'antenatal'
}

export function isPostnatalReviewDue(file: MaternityFile) {
  return (['sixDays', 'sixWeeks'] as PostnatalReviewKind[]).some(
    (kind) => getPostnatalReviewStatus(file, kind).isDue,
  )
}

export function countMaternityWardStages(files: MaternityFile[]) {
  const counts = {
    all: 0,
    antenatal: 0,
    labour: 0,
    postnatal: 0,
  }
  files.forEach((file) => {
    if (isPostnatalReviewDue(file)) {
      counts.postnatal += 1
      return
    }
    counts.all += 1
    const stage = getMaternityWardStage(file)
    if (stage !== 'postnatal') counts[stage] += 1
  })
  return counts
}

export function filterMaternityWardFiles(
  files: MaternityFile[],
  filter: MaternityWardFilter,
) {
  if (filter === 'postnatal') return files.filter(isPostnatalReviewDue)
  const onWard = files.filter((file) => !isPostnatalReviewDue(file))
  if (filter === 'all') return onWard
  return onWard.filter((file) => getMaternityWardStage(file) === filter)
}

export const maternityWardFilterLabels: Record<MaternityWardFilter, string> = {
  all: 'Active maternity files',
  antenatal: 'Admitted / antenatal',
  labour: 'In labour now',
  postnatal: 'Due for postnatal review',
}
